export const translations = {
  mainDrawer: {
    closePanel: {
      'en-150': 'Close Panel',
      'sk-SK': 'Zavrieť panel'
    },
    filters: {
      'en-150': 'Filter',
      'sk-SK': 'Filter'
    },
    views: {
      'en-150': 'View',
      'sk-SK': 'Zobrazenie'
    },
    sync: {
      'en-150': 'Refresh',
      'sk-SK': 'Obnoviť'
    },
    backToTasr: {
      'en-150': 'Services',
      'sk-SK': 'Servisy'
    },
    hungarianEvents: {
      'en-150': 'Hungarian events',
      'sk-SK': 'Maďarské udalosti'
    },
    settings: {
      'en-150': 'Settings',
      'sk-SK': 'Nastavenia'
    },
    manual: {
      'en-150': 'Manual',
      'sk-SK': 'Manuál'
    },
    exportEvents: {
      'en-150': 'Export events',
      'sk-SK': 'Export udalostí'
    },
    refreshMessage: {
      'en-150': 'Last refreshed',
      'sk-SK': 'Aktualizácia dát'
    },
    upToDateMessage: {
      'en-150': 'Events are up to date',
      'sk-SK': 'Dáta sú aktuálne'
    },
    adminZone: {
      'en-150': 'Administration',
      'sk-SK': 'Administratíva'
    }
  }
}
